export type MktVersionTypes = "v4";
export function versionToPathPrefix(version: MktVersionTypes) {
  if (version === "v4") return "promotion";
  return `${version}`;
}
